// extracted by mini-css-extract-plugin
export default {"carousel":"_G-z"};